import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
import { CommonService } from 'src/app/service/common-service';
//import { environment } from '../../environments/environment';
interface JwtPayload {
  [x: string]: string;
  Employee_Code: string;
  Clients: any;
}
export class Token {
    Email_Id: string;
    constructor(private router: Router) {

    }
    GetToken() {

        var token = sessionStorage.getItem(this.LoginTokenKey);
        if (token != null) {
            return token;
        }
        else {
            this.router.navigate(['/login']);
        }
    }
    public LoginTokenKey = "access_token";
    public TokenValue: string = null;
    public UserId: any = 0;
    public Full_Name: string = null;
    public Role: string = null;
    public FirstLogin;
    public Employee_Code;
    Clients = Array<Client>();
    public LoginTokenClientData = "access_client_data";
    //public AESTokenKey = "access_AES_Token";
    UserClients = [];

    SetLoginToken(Token: string): any {
        sessionStorage.setItem(this.LoginTokenKey, Token);
    }
    SetIsFirstLogin(isFirst: any) {
        sessionStorage.setItem(this.FirstLogin, isFirst)
    }
    getIsFirstLogin() {
        return sessionStorage.getItem(this.FirstLogin)
    }

    SetLoginAESToken(AESToken: string): any {
        sessionStorage.setItem(this.LoginTokenKey, AESToken);
    }

    GetUserData() {
        this.TokenValue = CommonService.decryptData(sessionStorage.getItem(this.LoginTokenKey))
        //let data = jwt_decode(this.TokenValue);
          const data = jwt_decode<JwtPayload>(this.TokenValue);
        // console.log('getUser : ', data);
        //this.TokenValue = sessionStorage.getItem(this.LoginTokenKey);
        this.Full_Name = data.Full_Name;
        this.UserId = data.User_Id;
        this.Role = data.Role_Name;
        //this.Clients = data.Clients;
        this.Clients = JSON.parse(sessionStorage.getItem(this.LoginTokenClientData));
        this.Employee_Code = data.Employee_Code;
        this.FirstLogin = data.Is_First_Login;
        this.Email_Id = data.Email_Id;
        return this;

    }



    ClearUserData() {
        sessionStorage.clear();
    }

    Exists() {

        let flag: boolean = true

        if (sessionStorage.getItem("access_token") == null) {
            flag = false
        }

        return flag;
    }

    // SetLoginClientData
    SetLoginClientData(clientData) {
        sessionStorage.setItem(this.LoginTokenClientData, JSON.stringify(clientData.Clients));
    }

    GetUserClientData() {
        let data = JSON.parse(sessionStorage.getItem(this.LoginTokenClientData));
        this.UserClients = data
        return this.UserClients;
    }
}

export class Client {
    Client_Id: number;
    Client_Name: string;
}
